import React, { useState, useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import Cookies from 'js-cookie';

const CART_CREATION_COOKIE = 'cart_creation_time';
const CART_EXPIRATION_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds

const CartUrgencyNotice = ({ data }) => {
  const [timeLeft, setTimeLeft] = useState(CART_EXPIRATION_TIME);

  useEffect(() => {
    const initializeTimer = () => {
      const storedCreationTime = Cookies.get(CART_CREATION_COOKIE);

      if (!storedCreationTime) {
        // If no cookie exists, set the current time as creation time
        Cookies.set(CART_CREATION_COOKIE, Date.now(), { expires: 1 }); // Expires in 1 day
        return CART_EXPIRATION_TIME;
      }

      const elapsedTime = Date.now() - parseInt(storedCreationTime, 10);
      return Math.max(0, CART_EXPIRATION_TIME - elapsedTime);
    };

    setTimeLeft(initializeTimer());

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = Math.max(0, prevTime - 1000);
        if (newTime === 0) {
          clearInterval(timer);
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useUpdateEffect(() => {
    resetTimer();
  }, [data.item_count]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const resetTimer = () => {
    Cookies.set(CART_CREATION_COOKIE, Date.now(), { expires: 1 });
    setTimeLeft(CART_EXPIRATION_TIME);
  };

  if (timeLeft === 0) {
    return null;
  }

  if (data.item_count === 0) {
    return null;
  }

  return (
    <div className="cart-urgency-notice">
      <p>
        <strong>Hurry!</strong> Your cart will expire in <span className="countdown">{formatTime(timeLeft)}</span>
      </p>
    </div>
  );
};

export default CartUrgencyNotice;
